import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {IonicModule} from "@ionic/angular";
import {RecoverPasswordPageRoutingModule} from "./recover-password.routing.module";
import {RecoverPasswordPage} from "./recover-password.page";



@NgModule({
  declarations: [RecoverPasswordPage],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    RecoverPasswordPageRoutingModule
  ]
})
export class RecoverPasswordPageModule { }
